import React from 'react';

const classNamePrefixForWebComponentRendering = 'nxgn7890';

enum RenderMode {
    App = 1, // Default rendering mode
    WebComponent, // Used to render header/footer as web components in other Ed2Go apps
}
const RenderContext = React.createContext({ mode: RenderMode.App });
RenderContext.displayName = 'ApplicationRenderContext';

export { RenderContext, RenderMode, classNamePrefixForWebComponentRendering };
